import type React from 'react';

import { ProgressStepper, Separator, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { Html } from 'src/app/shared/components/html';

import { DesktopShareAssetHeader } from './components/DesktopShareAssetHeader';
import { PetitionMedia } from './components/PetitionMedia';
import { ShareActions } from './components/ShareActions';
import { ShareFeed } from './components/ShareFeed';
import { SharingGoalFlow } from './components/SharingGoalFlow';
import { usePageBody } from './hooks/usePageBody';

export const PageBody: React.FC = () => {
	const {
		data: {
			heading,
			subHeading,
			warning,
			shareFeed,
			pageTitle,
			shouldShowSharingGoalFlow,
			showPetitionMedia,
			desktopShareAssetHeader,
		},
	} = usePageBody();

	const cardClassName = cn('bg-background-base relative rounded-2xl py-7 md:py-9', {
		'elevation-elevated': !desktopShareAssetHeader,
		'shadow-[0px_-4px_32px_0px_rgba(0,0,0,0.1)]': !!desktopShareAssetHeader,
	});

	return (
		<div className="mx-auto max-w-[610px]">
			{showPetitionMedia && <PetitionMedia />}
			{desktopShareAssetHeader && (
				<DesktopShareAssetHeader url={desktopShareAssetHeader.url} variation={desktopShareAssetHeader.variation} />
			)}
			{shouldShowSharingGoalFlow ? (
				<div className={cardClassName}>
					<SharingGoalFlow />
				</div>
			) : (
				<div className={cardClassName}>
					<div className="flex flex-col gap-7 px-6 md:gap-9 md:px-10">
						<div className="flex flex-col justify-center gap-3 pb-3">
							{pageTitle && <Text className="text-center">{pageTitle}</Text>}
							<ProgressStepper currentStepNumber={3} numberOfSteps={3} />
						</div>
						<div className="flex flex-col gap-3 md:gap-4" data-qa="description">
							<Text size="medium" variant="heading" as="h1" className="m-0">
								{heading}
							</Text>
							<Text fontWeight="light" variant="body" className="text-typography-weak md:text-lg">
								<Html html={subHeading} noContentStyles />
							</Text>
							{warning && (
								<Text as="div" size="large" className="mt-4" data-qa="warning">
									<Html html={warning} noContentStyles />
								</Text>
							)}
						</div>

						<ShareActions />

						{shareFeed.showFeed && <Separator className="m-0" />}
					</div>

					{shareFeed.showFeed && (
						<div className="relative mt-7 h-full overflow-hidden md:mt-9">
							<ShareFeed items={shareFeed.items} data-qa="share-feed" />
						</div>
					)}
				</div>
			)}
		</div>
	);
};
